import CardsContainer from "./CardsContainer/CardsContainer";
import FeaturedCategories from "./FeaturedCategories/FeaturedCategories";
import FiltersAndSorts from "./FiltersAndSorts/FiltersAndSorts"

const HomeComponent = {
    CardsContainer,
    FeaturedCategories,
    FiltersAndSorts
}

export default HomeComponent;